module.exports = __webpack_public_path__ + "img/2.92610616.png";